import {
  type AudioProcessorResult,
  createAudioProcessor,
} from '@/shared-utilities';

import { AUDIO_CHUNK_DURATION_MS } from './shared-survey-mobile-ut-phone.consts';

export function createMobileUtMicMixer(
  audioContext: AudioContext,
  stream: MediaStream
) {
  const masterDestination = audioContext.createMediaStreamDestination();
  const micSource = audioContext.createMediaStreamSource(stream);
  micSource.connect(masterDestination);

  return { masterDestination, micSource };
}

export function connectMobileUtHyperbeamAudio(
  audioContext: AudioContext,
  masterDestination: MediaStreamAudioDestinationNode,
  track: MediaStreamTrack
): MediaStreamAudioSourceNode {
  const source = audioContext.createMediaStreamSource(new MediaStream([track]));
  source.connect(masterDestination);
  source.connect(audioContext.destination);

  return source;
}

export function startMobileUtAudioRecorder(
  masterDestination: MediaStreamAudioDestinationNode,
  onChunk: (blob: Blob) => void
) {
  const supportedMime =
    ['audio/webm', 'audio/mp4', 'audio/ogg'].find((mime) =>
      MediaRecorder.isTypeSupported(mime)
    ) || '';

  const recorder = new MediaRecorder(
    masterDestination.stream,
    supportedMime ? { mimeType: supportedMime } : undefined
  );
  recorder.ondataavailable = (event) => {
    if (event.data.size > 0) onChunk(event.data);
  };
  recorder.start(AUDIO_CHUNK_DURATION_MS);

  return { recorder, mimeType: supportedMime || 'audio/webm' };
}

export function createMobileUtAudioProcessor(
  audioContext: AudioContext,
  getWorker: () => Worker | null
): Promise<AudioProcessorResult> {
  return createAudioProcessor(audioContext, {
    onAudioLevel: () => undefined,
    onAudioData: (data, timestamp) => {
      getWorker()?.postMessage(
        {
          id: `audio_${timestamp}`,
          type: 'AUDIO_DATA',
          payload: data,
        },
        [data]
      );
    },
  });
}

export function connectMobileUtAudioProcessor(
  audioContext: AudioContext,
  stream: MediaStream,
  processor: AudioProcessorResult['processor']
): MediaStreamAudioSourceNode {
  const source = audioContext.createMediaStreamSource(stream);
  source.connect(processor);
  processor.connect(audioContext.destination);

  return source;
}
